import {Assert} from "common/Assert";

export function CourseFacade( course ){

    Assert.checkArgument( course );

    // revealing public api
    return {

        /**
         * Gets the class name for the course
         *
         * @returns {String} CookieCourse, PublisherCourse, ScormCourse or Scorm2004Course
         */
        getClassName: () => course.getClassName(),

        /**
         * The profile controller synchronizes the course user data with the lms
         * and provides this data for refreshing the UI.
         *
         * @returns {Object} profile controller
         */
        getProfileController: () => course.getProfileController(),

        /**
         * Sets the name of the user, used e.g. in certificate.
         *
         * @param {String} username
         */
        setUsername: ( username) => course.setUsername( username ),

        /**
         * Gets the name of the user.
         *
         * @returns {String} user name
         */
        getUsername: () => course.getUsername(),

        /**
         * Gets the storage system for the course.
         *
         * @returns {String} "local_maschine", "scorm_lms" or "tt_accelerator"
         */
        getStorageSystem : () => course.getStorageSystem(),

        /**
         * Gets the storage method for the course.
         *
         * @returns {String} "cookies", "scorm.scorm2004" (scorm 1.3) or "jsapi" (scorm 1.2)
         */
        getStorageMethod: () => course.getStorageMethod(),

        /**
         * Gets mastery score.
         * For a scorm 1.3 course, the mastery score is returned as a real (e.g. 0.8)
         *
         * @returns {Number} mastery score
         */
        getCourseMasteryScore: () => course.getCourseMasteryScore(),

        /**
         * Checks for the possabillity to start multiple SCOs at the same time.
         *
         * @returns {boolean} true/false
         */
        isMultiScoLaunchAllowed: () => course.isMultiScoLaunchAllowed(),

        /**
         *
         * @returns {boolean} true
         */
        useScoLaunchParams: () => course.useScoLaunchParams(),

        /**
         * initializes the course lessons that will use for the course status
         * calculation (score, completed, etc.)
         *
         * @param {Boolean} useAssessments if true the lessons exported in "assessment mode" will be used,
         *                  otherwise the lessons exported in "learning mode".
         */
        initScoreIDs: ( useAssessments ) => course.initScoreIDs( useAssessments ),

        /**
         * marks the given sequence as started/open
         * @param {String} id
         */
        prepareSequenceLaunch: ( id ) => course.prepareSequenceLaunch( id ),

        /**
         * checks if a sequence is connected/open
         *
         * @return {Boolean}
         */
        isSequenceConnected: () => course.isSequenceConnected(),

        /**
         * initialize/add new sequence data
         * @param {String} id
         * @returns {Object} sequence data for <id>
         */
        initSequenceData: ( id ) => course.initSequenceData( id ),

        /**
         * gets the currently stored data for a sequence
         * @param {String} id
         * @return {Object} sequence data of the element with id <sId> or null
         */
        getSequenceData: (id) => course.getSequenceData( id ),

        /**
         * stores data for a sequence
         * @param {String} id
         * @param {Object} newSequenceData @Nullable
         * @returns {Object} sequence data of <id> extended by newSequenceData or null
         */
        setSequenceData: ( id, newSequenceData ) => course.setSequenceData( id, newSequenceData ),

        /**
         * gets the sequence data map
         * returns {Object} seqeunceDataMap
         */
        getSequenceDataMap: () => course.getSequenceDataMap(),

        /**
         * clears the the sequence data map
         */
        clearSequenceDataMap: () => course.clearSequenceDataMap(),

        /**
         * The current status will be committed to the lms and
         * the lms session will be terminated.
         */
        terminate: () => course.terminate(),

        /**
         * checks if special browser handling is necessary for the course
         *
         * @deprecated
         *
         * @return {Boolean} true
         */
        handleBrowserOnTerminate: () => course.handleBrowserOnTerminate(),

        /**
         * refreshes the course view
         */
        refreshStatus: () => course.refreshStatus(),

        /**
         * Initializes the events, not necessary due to the course initializes the events on creating.
         * This api function is only used by the initial_2013 configuration to initialize the landing page and seams not
         * to be required.
         */
        initEventListener: () => {}
    };
}
